import store_operation from "@/store/mods/caisse/operations"
import DateFilter from '@/components/date-filter';
import $ from 'jquery';

export default {
    name: 'creance-patients',
    components: {
        DateFilter
    },
    props: {
        is_dashboard: {
            type: Number,
            default: () => 0
        }
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_error: false,
            list_creance_patients: [],

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            fields: [
                'patient', 'sexe', { key: 'age', label: 'Âge' },  { key: 'telephone', label: 'Téléphone' }, 
                { key: 'total_differe', label: 'Total différé à payer' }, 
                { key: 'total_partial', label: 'Total reste à payer' },
                { key: 'total_rap', label: 'Montant total à solder' }
            ],

            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,

            tot_differes: 0,
            tot_reste_a_payer: 0,
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter-creances').modal('show')
                }
            }            
        },

        curr_month() {
            this.list_creance_patients = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.is_month = true
            this.current_date_filter = data
            this.getListeCreancePatients(data)
        },
    },
    
    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        this.monthOfYear[0].lib = "Toutes les périodes"

        this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", {});
        this.$store.commit("SET_PAYMENT_ACTION", '');

        const data = {
            month: this.curr_month.id,
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.getListeCreancePatients(data)
    },

    methods: {
        getListeCreancePatients(data) {
            this.is_error = false
            this.is_loading = true

            store_operation.getPatientCreances(data).then((response) => {
                this.list_creance_patients = (response.patients)?response.patients:[]
                this.tot_differes = response.total_differes
                this.tot_reste_a_payer = response.total_rap
                if (this.list_creance_patients.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                this.is_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            this.list_creance_patients = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false
            this.getListeCreancePatients(data)
        },

        goToPayment(data_type, item) {
            const selected_patient = {
                patient_id: parseInt(item.patient_id),
                nom: item.patient,
                prenoms: "",
                nom_patient: item.patient,
                sexe: item.sexe,
                telephone_mobile: item.telephone,
                age: item.age,
                num_dossier: item.num_dossier
            }

            this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", selected_patient);
            this.$store.commit("SET_PAYMENT_ACTION", data_type);
            this.$router.push({ "path": "/factures/patients-operations" })
        },
    }
}